<template>
  <div>
    <div
      v-if="$apollo.loading"
      class="text-center"
    >
      <BtnComponent loading disabled>&nbsp;</BtnComponent>
    </div>
    <div v-if="unit">
      <div
        v-if="isBackwash"
        class="mb-5"
      >
        <FilterBackwashTimer
          :backwash="unit.backwash"
        />

        <FilterBackwash
          :backwash="unit.backwash"
        />
      </div>
      <div
        v-else
        class="mb-5"
      >
        <div
          v-if="unit?.statusMessages?.length > 0"
          class="messages mb-3"
        >
          <StatusMessageGroup
            v-for="(statusMessages, severity) in groupedStatusMessages"
            :key="severity"
            :status-messages="statusMessages"
            :severity="severity"
          />
        </div>
        <div
          class="status-grid"
          :class="{ 'contains-messages': unit?.statusMessages?.length > 0 }"
        >
          <div class="card-grid">
            <template
              v-for="(statusValue, i) in unit?.statusValues?.primary"
              :key="i"
            >
              <UpcomingFiltrationPeriodCard
                v-if="statusValue.type === 'UPCOMING_FILTRATION_PERIOD'"
                :status-value="statusValue"
              />
              <WaterLevelCard
                v-else-if="statusValue.type === 'WATER_LEVEL'"
                :status-value="statusValue"
              />
              <StatusCard
                v-else
                :status-value="statusValue"
              />
            </template>
          </div>
          <div class="pl-0h pr-0h" style="max-width: 40rem">
            <table>
              <tbody>
                <template
                  v-for="(statusValue, i) in unit?.statusValues?.secondary"
                  :key="i"
                >
                  <UpcomingFiltrationPeriodRow
                    v-if="statusValue.type === 'UPCOMING_FILTRATION_PERIOD'"
                    :status-value="statusValue"
                  />
                  <WaterLevelRow
                    v-else-if="statusValue.type === 'WATER_LEVEL'"
                    :status-value="statusValue"
                  />
                  <UnitModeRow
                    v-else-if="statusValue.type === 'MODE'"
                    :status-value="statusValue"
                  />
                  <StatusRow
                    v-else
                    :status-value="statusValue"
                  />
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusCard from '@acs/components-library/src/components/deviceDetail/status/StatusCard.vue';
import StatusRow from '@acs/components-library/src/components/deviceDetail/status/StatusRow.vue';
import UpcomingFiltrationPeriodCard
  from '@acs/components-library/src/components/deviceDetail/status/UpcomingFiltrationPeriodCard.vue';
import UpcomingFiltrationPeriodRow
  from '@acs/components-library/src/components/deviceDetail/status/UpcomingFiltrationPeriodRow.vue';
import WaterLevelCard from '@acs/components-library/src/components/deviceDetail/status/WaterLevelCard.vue';
import WaterLevelRow from '@acs/components-library/src/components/deviceDetail/status/WaterLevelRow.vue';
import UnitModeRow from '@acs/components-library/src/components/deviceDetail/status/UnitModeRow.vue';
import StatusMessageGroup from '@acs/components-library/src/components/deviceDetail/statusMessage/StatusMessageGroup.vue';
import FilterBackwashTimer from '@acs/components-library/src/components/deviceDetail/statusMessage/FilterBackwashTimer.vue';
import FilterBackwash from '@acs/components-library/src/components/deviceDetail/required/FilterBackwash.vue';
import BtnComponent from '@acs/components-library/src/components/common/Btn.vue';

import { ViewQuery, ViewSubscription } from '@acs/components-library/src/gql/live/UnitDetailStatus.js';
import { isDemo } from '@acs/components-library/src/demo.js';

export default {
  components: {
    FilterBackwash,
    UpcomingFiltrationPeriodRow,
    UpcomingFiltrationPeriodCard,
    StatusRow,
    StatusCard,
    WaterLevelCard,
    WaterLevelRow,
    UnitModeRow,
    StatusMessageGroup,
    FilterBackwashTimer,
    BtnComponent,
  },
  props: {
    sn: {
      type: String,
      required: true,
    },
    unpaired: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    unit() {
      return this.unitBySerialNumber;
    },
    isBackwash() {
      return this.unit?.backwash?.running;
    },
    groupedStatusMessages() {
      return this.unit?.statusMessages?.reduce((acc, statusMessage) => {
        if (!acc[statusMessage.severity]) acc[statusMessage.severity] = [];
        acc[statusMessage.severity].push(statusMessage);
        return acc;
      }, {});
    },
  },
  apollo: {
    unitBySerialNumber: {
      query: ViewQuery,
      variables() {
        return { sn: this.sn };
      },
      skip() {
        return this.unpaired || !this.sn;
      },
    },
    $subscribe: {
      unitStatus: {
        query: ViewSubscription,
        variables() {
          return { sn: this.sn };
        },
        skip() {
          return this.unpaired || !this.sn || isDemo();
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@acs/components-library/src/assets/styles/variables/sizes.scss';

.status-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  align-items: start;

  .card-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

@media (min-width: sizes.$tablet) {
  .status-grid {
    gap: 3rem;
    grid-template-columns: 3fr 2fr;
  }
}

</style>
